import { CarType } from "../types/CarType";

export const CarShipPrice = 2000;

export const CarsList: CarType[] = [
  {
    id: 0,
    brand: "Rolls royce",
    carName: "Rolls-Royce 20/25 HP Standard Sedan - $125,000",
    image: "rolls-low",
    qualityLvl: 5,
    basePrice: 125000,
  },
  {
    id: 1,
    brand: "Rolls royce",
    carName: "Rolls-Royce 20/25 HP Sports Saloon - $175,000",
    image: "rolls-medium",
    qualityLvl: 5,
    basePrice: 175000,
  },
  {
    id: 2,
    brand: "Rolls royce",
    carName: "Rolls-Royce Phantom II - $250,000",
    image: "rolls-high",
    qualityLvl: 5,
    basePrice: 250000,
  },
  {
    id: 3,
    brand: "Rolls royce",
    carName: "Rolls-Royce Phantom II Continental Limousine - $500,000",
    image: "rolls-extreme",
    qualityLvl: 5,
    basePrice: 500000,
  },
  {
    id: 4,
    brand: "Bentley",
    carName: "Bentley 4.5 Litre Standard Tourer  - $100,000",
    image: "bentley-low",
    qualityLvl: 5,
    basePrice: 100000,
  },
  {
    id: 5,
    brand: "Bentley",
    carName: "Bentley 4.5 Litre Sports Saloon  - $150,000",
    image: "bentley-medium",
    qualityLvl: 5,
    basePrice: 150000,
  },
  {
    id: 6,
    brand: "Bentley",
    carName: "Bentley Speed Six Saloon  - $200,000",
    image: "bentley-high",
    qualityLvl: 5,
    basePrice: 200000,
  },
  {
    id: 7,
    brand: "Bentley",
    carName: "Bentley 8 Litre Limousine by H.J. Mulliner  - $450,000",
    image: "bentley-extreme",
    qualityLvl: 5,
    basePrice: 450000,
  },
  {
    id: 8,
    brand: "Packard",
    carName: "Packard Standard Eight Model 726  - $75,000",
    image: "packard-low",
    qualityLvl: 4,
    basePrice: 75000,
  },
  {
    id: 9,
    brand: "Packard",
    carName: "Packard Standard Eight Model 733  - $125,000",
    image: "packard-medium",
    qualityLvl: 4,
    basePrice: 125000,
  },
  {
    id: 10,
    brand: "Packard",
    carName: "Packard Deluxe Eight Model 740  - $175,000",
    image: "packard-high",
    qualityLvl: 4,
    basePrice: 175000,
  },
  {
    id: 11,
    brand: "Packard",
    carName: "Packard Custom Eight Model 745 Convertible Sedan  - $350,000",
    image: "packard-extreme",
    qualityLvl: 4,
    basePrice: 350000,
  },
  {
    id: 12,
    brand: "Cadillac",
    carName: "Cadillac Series 353 Standard Sedan  - $70,000",
    image: "cadillac-low",
    qualityLvl: 4,
    basePrice: 70000,
  },
  {
    id: 13,
    brand: "Cadillac",
    carName: "Cadillac Series 353 Town Sedan  - $120,000",
    image: "cadillac-medium",
    qualityLvl: 4,
    basePrice: 120000,
  },
  {
    id: 14,
    brand: "Cadillac",
    carName: "Cadillac V-16 Imperial Sedan  - $180,000",
    image: "cadillac-high",
    qualityLvl: 4,
    basePrice: 180000,
  },
  {
    id: 15,
    brand: "Cadillac",
    carName: "Cadillac V-16 Roadster  - $275,000",
    image: "cadillac-extreme",
    qualityLvl: 4,
    basePrice: 275000,
  },
  {
    id: 16,
    brand: "Lincoln",
    carName: "Lincoln Model L  - $60,000",
    image: "lincoln-low",
    qualityLvl: 4,
    basePrice: 60000,
  },
  {
    id: 17,
    brand: "Lincoln",
    carName: "Lincoln Model K sedan  - $100,000",
    image: "lincoln-medium",
    qualityLvl: 4,
    basePrice: 100000,
  },
  {
    id: 18,
    brand: "Lincoln",
    carName: "Lincoln Model L Town Car  - $155,000",
    image: "lincoln-high",
    qualityLvl: 4,
    basePrice: 155000,
  },
  {
    id: 19,
    brand: "Lincoln",
    carName: "Lincoln Model L Limousine  - $250,000",
    image: "lincoln-extreme",
    qualityLvl: 4,
    basePrice: 250000,
  },
  {
    id: 20,
    brand: "Chrysler",
    carName: "Chrysler Model 66 sedan  - $40,000",
    image: "chrysler-low",
    qualityLvl: 3,
    basePrice: 40000,
  },
  {
    id: 21,
    brand: "Chrysler",
    carName: "Chrysler Series 70 sedan  - $75,000",
    image: "chrysler-medium",
    qualityLvl: 3,
    basePrice: 75000,
  },
  {
    id: 22,
    brand: "Chrysler",
    carName: "Chrysler Imperial Model 80 Roadster  - $90,000",
    image: "chrysler-high",
    qualityLvl: 3,
    basePrice: 90000,
  },
  {
    id: 23,
    brand: "Chrysler",
    carName: "Chrysler Imperial Custom Series 8 Limousine  - $150,000",
    image: "chrysler-extreme",
    qualityLvl: 3,
    basePrice: 150000,
  },
  {
    id: 24,
    brand: "Buick",
    carName: "Buick Series 40  - $15,000",
    image: "buick-low",
    qualityLvl: 3,
    basePrice: 15000,
  },
  {
    id: 25,
    brand: "Buick",
    carName: "Buick Series 50 sedan  - $35,000",
    image: "buick-medium",
    qualityLvl: 3,
    basePrice: 35000,
  },
  {
    id: 26,
    brand: "Buick",
    carName: "Buick Series 60 sedan  - $50,000",
    image: "buick-high",
    qualityLvl: 3,
    basePrice: 50000,
  },
  {
    id: 27,
    brand: "Buick",
    carName: "Buick Series 90 Limited  - $100,000",
    image: "buick-extreme",
    qualityLvl: 3,
    basePrice: 100000,
  },
  {
    id: 28,
    brand: "DeSoto",
    carName: "DeSoto Model K  - $16,000",
    image: "desoto-low",
    qualityLvl: 3,
    basePrice: 16000,
  },
  {
    id: 29,
    brand: "DeSoto",
    carName: "DeSoto CF Eight sedan  - $25,000",
    image: "desoto-medium",
    qualityLvl: 3,
    basePrice: 25000,
  },
  {
    id: 30,
    brand: "DeSoto",
    carName: "DeSoto Deluxe Eight sedan  - $40,000",
    image: "desoto-high",
    qualityLvl: 3,
    basePrice: 40000,
  },
  {
    id: 31,
    brand: "DeSoto",
    carName: "DeSoto Custom Imperial Limousine  - $75,000",
    image: "desoto-extreme",
    qualityLvl: 3,
    basePrice: 75000,
  },
  {
    id: 32,
    brand: "Dodge",
    carName: "Dodge DC Series sedan  - $16,000",
    image: "dodge-low",
    qualityLvl: 3,
    basePrice: 16000,
  },
  {
    id: 33,
    brand: "Dodge",
    carName: "Dodge Eight Series DH sedan  - $25,000",
    image: "dodge-medium",
    qualityLvl: 3,
    basePrice: 25000,
  },
  {
    id: 34,
    brand: "Dodge",
    carName: "Dodge Senior Six sedan  - $35,000",
    image: "dodge-high",
    qualityLvl: 3,
    basePrice: 35000,
  },
  {
    id: 35,
    brand: "Dodge",
    carName: "Dodge Deluxe Eight Limousine  - $75,000",
    image: "dodge-extreme",
    qualityLvl: 3,
    basePrice: 75000,
  },
  {
    id: 36,
    brand: "Hudson",
    carName: "Hudson Greater Eight  - $8,000",
    image: "hudson-low",
    qualityLvl: 2,
    basePrice: 8000,
  },
  {
    id: 37,
    brand: "Hudson",
    carName: "Hudson Essex Super Six  - $16,000",
    image: "hudson-medium",
    qualityLvl: 2,
    basePrice: 16000,
  },
  {
    id: 38,
    brand: "Hudson",
    carName: "Hudson Custom Eight  - $27,000",
    image: "hudson-high",
    qualityLvl: 2,
    basePrice: 27000,
  },
  {
    id: 39,
    brand: "Hudson",
    carName: "Hudson Greater Eight Custom Limousine  - $50,000",
    image: "hudson-extreme",
    qualityLvl: 2,
    basePrice: 50000,
  },
  {
    id: 40,
    brand: "Nash",
    carName: "Nash 400 Series sedan  - $8,000",
    image: "nash-low",
    qualityLvl: 2,
    basePrice: 8000,
  },
  {
    id: 41,
    brand: "Nash",
    carName: "Nash Standard Six sedan  - $16,000",
    image: "nash-medium",
    qualityLvl: 2,
    basePrice: 16000,
  },
  {
    id: 42,
    brand: "Nash",
    carName: "Nash Advanced Eight sedan  - $27,000",
    image: "nash-high",
    qualityLvl: 2,
    basePrice: 27000,
  },
  {
    id: 43,
    brand: "Nash",
    carName: "Nash Ambassador Eight Limousine  - $50,000",
    image: "nash-extreme",
    qualityLvl: 2,
    basePrice: 50000,
  },
  {
    id: 44,
    brand: "Studebaker",
    carName: "Studebaker Six Standard Sedan  - $8,000",
    image: "studebaker-low",
    qualityLvl: 2,
    basePrice: 8000,
  },
  {
    id: 45,
    brand: "Studebaker",
    carName: "Studebaker Commander Sedan  - $16,000",
    image: "studebaker-medium",
    qualityLvl: 2,
    basePrice: 16000,
  },
  {
    id: 46,
    brand: "Studebaker",
    carName: "Studebaker President Eight Sedan  - $27,000",
    image: "studebaker-high",
    qualityLvl: 2,
    basePrice: 27000,
  },
  {
    id: 47,
    brand: "Studebaker",
    carName: "Studebaker President Convertible Coupe  - $50,000",
    image: "studebaker-extreme",
    qualityLvl: 2,
    basePrice: 50000,
  },
  {
    id: 48,
    brand: "Ford",
    carName: "Ford Model A  - $5,000",
    image: "ford-low",
    qualityLvl: 1,
    basePrice: 5000,
  },
  {
    id: 49,
    brand: "Ford",
    carName: "Ford Model A Deluxe Roadster  - $12,000",
    image: "ford-medium",
    qualityLvl: 1,
    basePrice: 12000,
  },
  {
    id: 50,
    brand: "Ford",
    carName: "Ford Model A Town Car  - $21,000",
    image: "ford-high",
    qualityLvl: 1,
    basePrice: 21000,
  },
  {
    id: 51,
    brand: "Ford",
    carName: "Ford Model A Tudor Limousine  - $42,000",
    image: "ford-extreme",
    qualityLvl: 1,
    basePrice: 42000,
  },
  {
    id: 52,
    brand: "Chervolet",
    carName: "Chevrolet Universal Series AD Coach  - $5,000",
    image: "chevrolet-low",
    qualityLvl: 1,
    basePrice: 5000,
  },
  {
    id: 53,
    brand: "Chervolet",
    carName: "Chevrolet Independence Series AE sedan  - $12,000",
    image: "chevrolet-medium",
    qualityLvl: 1,
    basePrice: 12000,
  },
  {
    id: 54,
    brand: "Chervolet",
    carName: "Chevrolet Series AD Universal Phaeton  - $21,000",
    image: "chevrolet-high",
    qualityLvl: 1,
    basePrice: 21000,
  },
  {
    id: 55,
    brand: "Chervolet",
    carName: "Chevrolet Series AD Universal Landau  - $42,000",
    image: "chevrolet-extreme",
    qualityLvl: 1,
    basePrice: 42000,
  },
  {
    id: 56,
    brand: "Austin",
    carName: "Austin 7  - $5,000",
    image: "austin-low",
    qualityLvl: 1,
    basePrice: 5000,
  },
  {
    id: 57,
    brand: "Austin",
    carName: "Austin 12/4  - $12,000",
    image: "austin-medium",
    qualityLvl: 1,
    basePrice: 12000,
  },
  {
    id: 58,
    brand: "Austin",
    carName: "Austin 16  - $15,000",
    image: "austin-high",
    qualityLvl: 1,
    basePrice: 15000,
  },
  {
    id: 59,
    brand: "Austin",
    carName: "Austin 20/6 Mayfair Limousine  - $37,000",
    image: "austin-extreme",
    qualityLvl: 1,
    basePrice: 37000,
  },
  {
    id: 60,
    brand: "Plymouth",
    carName: "Plymouth Model U  - $5,000",
    image: "plymouth-low",
    qualityLvl: 1,
    basePrice: 5000,
  },
  {
    id: 61,
    brand: "Plymouth",
    carName: "Plymouth 30U sedan  - $12,000",
    image: "plymouth-medium",
    qualityLvl: 1,
    basePrice: 12000,
  },
  {
    id: 62,
    brand: "Plymouth",
    carName: "Plymouth PA Deluxe sedan  - $15,000",
    image: "plymouth-high",
    qualityLvl: 1,
    basePrice: 15000,
  },
  {
    id: 63,
    brand: "Plymouth",
    carName: "Plymouth PA Deluxe Limousine  - $37,000",
    image: "plymouth-extreme",
    qualityLvl: 1,
    basePrice: 37000,
  },
];
